var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"btn",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))])]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"right"},[_c('span',{staticClass:"btn",on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.confirmText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }